import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7772cadc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "settings" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = ["onUpdate:modelValue"]
const _hoisted_4 = { class: "actions" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "System", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "IP Address", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "MAC Address", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Hostname", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Uptime", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Paths", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", null, "Settings: " + _toDisplayString(_ctx.name) + " v" + _toDisplayString(_ctx.version), 1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("section", null, [
        _createElementVNode("table", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.config, (value, key) => {
            return (_openBlock(), _createElementBlock("tr", { key: key }, [
              _createElementVNode("td", null, _toDisplayString(key), 1),
              _createElementVNode("td", null, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": ($event: any) => ((_ctx.config[key]) = $event)
                }, null, 8, _hoisted_3), [
                  [
                    _vModelText,
                    _ctx.config[key],
                    void 0,
                    { number: true }
                  ]
                ])
              ])
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)))
          }, "Save"),
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.reset && _ctx.reset(...args)))
          }, "Reset"),
          _createElementVNode("button", {
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.exit && _ctx.exit(...args)))
          }, "Exit")
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("section", null, [
        _hoisted_6,
        _createElementVNode("table", null, [
          _createElementVNode("tr", null, [
            _hoisted_7,
            _createElementVNode("td", null, _toDisplayString(_ctx.ip.address), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_8,
            _createElementVNode("td", null, _toDisplayString(_ctx.ip.mac), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_9,
            _createElementVNode("td", null, _toDisplayString(_ctx.os.hostname()), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_10,
            _createElementVNode("td", null, _toDisplayString(_ctx.os.uptime()), 1)
          ])
        ])
      ]),
      _createElementVNode("section", null, [
        _hoisted_11,
        _createElementVNode("table", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paths, ([name, path]) => {
            return (_openBlock(), _createElementBlock("tr", { key: name }, [
              _createElementVNode("td", null, _toDisplayString(name), 1),
              _createElementVNode("td", null, _toDisplayString(path), 1)
            ]))
          }), 128))
        ])
      ])
    ])
  ]))
}